import './iniciais.css';

/** Uma ou duas letras de `nome`: a primeira palavra e a última. Serve
 * também para o endereço que faz as vezes de nome na lista ("Rua das
 * Flores, 82" vira "R8"). */
function letrasDe(nome: string): string {
  const palavras = nome.trim().split(/\s+/).filter(Boolean);
  if (palavras.length === 0) return '?';
  const primeira = palavras[0]?.[0] ?? '';
  const ultima = palavras.length > 1 ? (palavras.at(-1)?.[0] ?? '') : '';
  return (primeira + ultima).toLocaleUpperCase('pt-BR');
}

/** O disco com as iniciais das pranchas 03.1 e 03.2.
 *
 * `aria-hidden`: é decoração. Quem nomeia a linha é o título ao lado, e um
 * leitor de tela soletrando "A O" antes de cada nome seria ruído em cada
 * parada da lista. */
export function Iniciais({
  nome,
  className,
}: {
  nome: string;
  className?: string;
}) {
  return (
    <span
      className={className ? `ds-iniciais ${className}` : 'ds-iniciais'}
      aria-hidden="true"
    >
      {letrasDe(nome)}
    </span>
  );
}
